import React, { useEffect, useState } from 'react'
import { images } from '../../assets'
import { Avatar, Button, DatePicker, Divider, Drawer, Flex, Input, Radio, Space, Tag, Typography } from 'antd'
import { FilterOutlined, MenuOutlined } from '@ant-design/icons'
import { database } from '../../utils/firebase'
import LabReqCard from './LabReqCard'
import { useNavigate } from 'react-router-dom'
import style from '../pendingApproval/pending.module.css'


const { Text, Link } = Typography
const { RangePicker } = DatePicker
const { Search } = Input

const LabRequistionPage = () => {
  const navigate = useNavigate()
  const [allLabs, setAllLabs] = useState(null)
  const [filtersDrawerOpen, setFiltersDrawerOpen] = useState(false)
  const [filters, setFilters] = useState({
    type: '',
    activity: '',
    status: '',
  })
  const [patientNameSearch, setPatientNameSearch] = useState(null)
  const [searchDiagnosis, setSearchDiagnosis] = useState(null)

  const getAllLabRequisitons = () => {
    database.ref('labTracking').limitToLast(500).once('value', (snapshot) => {
      const response = snapshot.val()
      console.log('response', response)
      setAllLabs(response)

    })
  }

  const getLabsBasedOnDate = (startDate, endDate) => {
    database.ref('labTracking').orderByChild('timestamp').startAt(startDate).endAt(endDate).once('value', (snapshot) => {
      const response = snapshot.val()
      console.log('response', response)
      setAllLabs(response)

    })
  }
  const onDateSelected = (dates) => {
    if (dates && dates.length === 2) {
      const startTime = (dates[0].startOf('day').valueOf())
      const endTime = (dates[1].endOf('day').valueOf())
      getLabsBasedOnDate(startTime, endTime)
      return
    }

  }

  useEffect(() => {
    getAllLabRequisitons()

  }, [])

  const renderFilteredCards = (isActivityOpen) => {
    return (

      Object.keys(allLabs || {}).filter((key) => {
        const currentLab = allLabs[key]
        if (isActivityOpen !== currentLab.activity) {
          return false
        }
        // Filter by patient name
        if (patientNameSearch && !currentLab?.patientName?.toLowerCase().includes(patientNameSearch.toLowerCase())) {
          return false
        }

        // Filter by diagnosis
        if (searchDiagnosis && !currentLab?.assessment?.toLowerCase().includes(searchDiagnosis.toLowerCase())) {
          return false
        }

        // Filter by status
        if (filters.status && filters.status?.toLowerCase() !== currentLab?.status?.toLowerCase()) {
          return false
        }

        // Filter by type
        if (filters.type && filters.type?.toLowerCase() !== currentLab?.type?.toLowerCase()) {
          return false
        }

        // Filter by activity
        if (filters.activity && filters.activity !== currentLab?.activity) {
          return false
        }

        return true
      }).sort((a, b) => allLabs[b].timestamp - allLabs[a].timestamp) // Sort by timestamp in descending order
        .map((key) => {
          const currentLab = allLabs[key]
          return <LabReqCard lab={currentLab} key={key} chatID={key} />
        })

    )
  }


  return (
    <Flex vertical className="p-4" gap="small">
      <Flex justify="space-between">
        <Button type="text" size="middle" icon={<MenuOutlined />} onClick={() => navigate(-1)} />
        <Avatar size="large" src={<img src={images.pastConsult} alt="avatar" />} />
      </Flex>
      <Flex vertical>
        <Text strong>Date:</Text>
        {/* <RangePicker onChange={onDateSelected} /> */}
         <div className={style.searchDate}>
        <RangePicker
          className={style.rangePicker}
          dropdownClassName={style.rangePickerDropdown}
          getPopupContainer={() => document.body}
          placement="bottomLeft"
          onChange={onDateSelected}
        />
        </div>
      </Flex>
      <Flex vertical>
        <Text strong>Search:</Text>
        <Search
          placeholder="Search patient"
          onSearch={setPatientNameSearch}
          allowClear
        />
      </Flex>
      <Flex vertical justify="space-between">
        <Text strong>Diagnosis:</Text>
        <Flex gap="small"> <
          Search placeholder="Search Diagnosis" onSearch={setSearchDiagnosis} allowClear />
          <FilterOutlined onClick={() => setFiltersDrawerOpen(true)} />

          <Drawer
            title="Filter"
            open={filtersDrawerOpen}
            onClose={() => setFiltersDrawerOpen(false)}
            placement="bottom"
            footer={null}>


            <Flex vertical>
              <Text strong>Type</Text>
              <Radio.Group
                onChange={(e) =>
                  setFilters((old) => ({
                    ...old,
                    type: e.target.value,
                  }))
                }
                value={filters.type}
              >
                <Space direction="vertical">
                  <Radio value="Lab">Lab</Radio>
                  <Radio value="Imaging">Imaging</Radio>
                </Space>
              </Radio.Group>
            </Flex>

            <Flex vertical style={{ marginTop: 20 }}>
              <Text strong>Activity</Text>
              <Radio.Group
                onChange={(e) =>
                  setFilters((old) => ({
                    ...old,
                    activity: e.target.value,
                  }))
                }
                value={filters.activity}
              >
                <Space direction="vertical">
                  <Radio value="open">Open</Radio>
                  <Radio value="closed">Close</Radio>
                  <Radio value="awaiting">Awaiting Reports</Radio>
                </Space>
              </Radio.Group>
            </Flex>
            <Flex vertical>
              <Radio.Group onChange={(e) => setFilters((old) => {
                return {
                  ...old,
                  status: e.target.value,
                }

              })} value={filters.status}>
                <Space direction="vertical" justify="space-evenly">
                  <Text strong>Status</Text>
                  <Radio value="normal">Normal </Radio>
                  <Radio value="critical">Critical</Radio>
                  <Radio value="abnormal">Abnormal</Radio>
                  <Radio value="undetermined">Undetermined</Radio>
                  <Radio value="pending">Pending results</Radio>
                </Space>
              </Radio.Group>
            </Flex>


          </Drawer>
        </Flex>
      </Flex>
      <Divider style={{ margin: '5px' }} />

      <Flex style={{ marginTop: '0' }}>
        {filters.status && <Tag color="red" closable
                                onClose={(e) => {
                                  e.preventDefault()
                                  setFilters((old) => ({
                                    ...old,

                                    status: null,
                                  }))
                                }}>{filters.status}</Tag>}
        {filters.activity && <Tag color="green" closable
                                  onClose={(e) => {
                                    e.preventDefault()
                                    setFilters((old) => ({
                                      ...old,
                                      activity: null,
                                    }))
                                  }}>{filters.activity}</Tag>}
        {filters.type && <Tag color="yellow" closable
                              onClose={(e) => {
                                e.preventDefault()
                                setFilters((old) => ({
                                  ...old,
                                  type: null,
                                }))
                              }}>{filters.type}</Tag>}
      </Flex>
      {/* Conditionally render the activity sections based on the selected filter */}
      {!filters.activity || filters.activity === 'open' ? (
        <>
          <Text
            strong
            style={{
              marginTop: '5px',
              background: '#C4C4C433',
              textAlign: 'center',
              color: '#727272',
            }}
          >
            Activity: Open
          </Text>
          {renderFilteredCards('open')}
        </>
      ) : null}

      {!filters.activity || filters.activity === 'awaiting' ? (
        <>
          <Text
            style={{
              marginTop: '5px',
              background: '#C4C4C433',
              textAlign: 'center',
              color: '#727272',
            }}
          >
            Activity: Awaiting Results
          </Text>
          {renderFilteredCards('awaiting')}
        </>
      ) : null}

      {!filters.activity || filters.activity === 'closed' ? (
        <>
          <Text
            style={{
              marginTop: '5px',
              background: '#C4C4C433',
              textAlign: 'center',
              color: '#727272',
            }}
          >
            Activity: Closed
          </Text>
          {renderFilteredCards('closed')}
        </>
      ) : null}

    </Flex>
  )
}

export default LabRequistionPage
